export default __webpack_public_path__ + "static/media/home-2.6861759b.jpg";